export const FILES_FORMAT_ALLOWED = ['application/pdf', '.xls', '.xlsx']

export const LOCAL_STORAGE_ITEM = {
    ACCESS_TOKEN: 'accessToken',
    TOKEN_EXPIRES_IN : 'expiresIn',
	TOKEN_EXPIRES_TIMESTAMP : 'expiresTimeStamp',
    USERNAME: 'username'
}

export const VersionNumber = 'SNAPSHOT 24is03c'

export const ClientName = 'Sensai'